import LinkBack from './LinkBack';

export default LinkBack;
